import { useSearch } from '@tanstack/react-router'
import { useAppStore } from '@/lib/app-store'

/** Inside an SDK embed or a token link, where the host page owns the chrome and the shells draw none. */
export function useIsEmbedded(): boolean {
  const search = useSearch({ strict: false })
  const fromStore = useAppStore(
    (state) => state.store.sdk || !!state.store.clientId || !!state.store.app || !!state.store.userToken,
  )
  return !!search.token || !!search.clientId || fromStore
}
